

const accountReceivable        = require ('./customer-report-account-receivable')
const accountReceivableAll     = require ('./customer-report-account-receivable-all')
const profitsAll               = require ('./customer-report-all-profit')
const profitPeriod             = require ('./customer-report-profit-period')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.reportType].start(detail)

}/**/




const obj = {
   
      accountReceivable:     { start: (detail)=>{  accountReceivable.start(detail)  }},
      accountReceivableAll:  { start: (detail)=>{  accountReceivableAll.start(detail)  }},
      profitPeriod:          { start: (detail)=>{  profitPeriod.start(detail)          }},
      profitsAll:            { start: (detail)=>{  profitsAll.start(detail)            }},




}


//Account Receivable 